<template>
  <div class="snags-page">
    <div class="main">
      <!-- <div class="snags-header">
        <h1 class="page-title">My Snags</h1>
        <div class="tabs-container">
          <div 
            class="tab-item" 
            :class="{ active: activeTab === 'incomplete' }"
            @click="activeTab = 'incomplete'"
          >
            未完成
          </div>
          <div 
            class="tab-item" 
            :class="{ active: activeTab === 'completed' }"
            @click="activeTab = 'completed'"
          >
            完成
          </div>
        </div>
      </div> -->

      <div class="snags-list" v-if="filteredSnags.length > 0">
        <SnagCard 
          v-for="snag in filteredSnags" 
          :key="snag.id" 
          :item="snag"
        />
      </div>
      <div class="empty-state" v-else-if="!loading">
        <p>No snags found for this status.</p>
      </div>
      <div class="loading-state" v-else>
        <p>Loading orders...</p>
      </div>
    </div>
  </div>
</template>

<script>
import SnagCard from '@/components/SnagCard.vue'
import { productApi } from '@/api/index.js'

export default {
  name: 'Snags',
  components: {
    SnagCard
  },
  data() {
    return {
      activeTab: 'incomplete',
      loading: false,
      snags: []
    }
  },
  computed: {
    filteredSnags() {
      return this.snags
      // if (this.activeTab === 'incomplete') {
      //   return this.snags.filter(s => !s.isCompleted)
      // } else {
      //   return this.snags.filter(s => s.isCompleted)
      // }
    }
  },
  mounted() {
    this.fetchOrderList()
  },
  methods: {
    async fetchOrderList() {
      this.loading = true
      try {
        const res = await productApi.getOrderList()
        if (res.code === 1) {
          console.log('Orders received:', res.data)
          this.snags = res.data.map(order => ({
            id: order.id,
            image: order.productimage.startsWith('http') ? order.productimage : `${this.httpUrl}${order.productimage}`,
            status: order.status === '0' ? 'Confirm order' : order.status === '1' ? 'Pending approval' : 'Completed',
            title: order.productname,
            cashback: `cash back via Wallet`,
            currentStep: parseInt(order.status) + 1, // 0->1, 1->2, 2->3
            isCompleted: order.status === '2',
            couponcode: order.couponcode,
            remark: order.remark
          }))
        }
      } catch (e) {
        console.error('Failed to fetch orders:', e)
        this.$toast('Failed to load orders')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.snags-page {
  min-height: 100vh;
  /* background: #f9f9f9; */
  padding: 40px 0;
}

.main {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.snags-header {
  margin-bottom: 30px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 24px;
}

.tabs-container {
  display: flex;
  gap: 30px;
  border-bottom: 1px solid #eee;
}

.tab-item {
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  color: #999;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
}

.tab-item:hover {
  color: #333;
}

.tab-item.active {
  color: #00d4aa;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #00d4aa;
}

.snags-list {
  margin-top: 20px;
}

.empty-state, .loading-state {
  text-align: center;
  padding: 60px 0;
  background: white;
  border-radius: 12px;
  color: #999;
  font-size: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}
</style>
